function a(u, f) {
  const c = f ? new Set(f) : void 0, s = [];
  function i(t) {
    t.forEach((n) => {
      s.push(n), !(n.isLeaf || !n.children || n.ignored) && (n.isGroup || // normal non-leaf node
      c === void 0 || c.has(n.key)) && i(n.children);
    });
  }
  return i(u), s;
}
export {
  a as flatten
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/treemate@0.3.11/~/treemate/es/flatten.js
// module id = 945
// module chunks = 41